import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Rx';

@Injectable()
export class AppsInstalledChangeService {
    private appsInstalledSource: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public appInstalledObservable = this.appsInstalledSource.asObservable();
    public appInstalled(value: boolean) {
        this.appsInstalledSource.next(value);
    }
}



// WEBPACK FOOTER //
// ./src/app/core/appsInstalled-change.service.ts